import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Range from './Range';
import FilterOption from './FilterOption';

const FilterName = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 32px 0 16px;
  z-index: ${props => props.open ? '21' : '1'};
  border-right: ${props => props.last ? '0px' : '1px'} solid #F2F2F2;
  user-select: none;
  font-size: 14px;
  color: ${props => props.hasSelected ? '#4A90E2' : '#787878'};
  cursor: pointer;

  &:after {
    content: "";
    position: absolute;
    top: calc(50% - ${props => props.open ? '6px' : '2px'});;
    right: 12px;
    width: 0px;
    height: 0px;
    border: 4px solid rgba(0,0,0,0);
    border-${props => props.open ? 'bottom' : 'top'}-color: #787878;
  }

  &:hover {

		color: #4A90E2;

		&:after {
			border-${props => props.open ? 'bottom' : 'top'}-color: #4A90E2;
		}

    &:before {
      content: "";
      position: absolute;
      bottom: 0px
      right: 0px;
      width: 100%;
      height: ${props => props.open ? '0px' : '2px'};
      background-color: #4A90E2;
    }
  }
`;

const FilterOptionsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: ${ props => props.left };
	right: ${ props => props.right };
  display: ${ props => props.open ? 'flex' : 'none'};
  flex-direction: column;
	min-width: 220px;
  height: ${ props => props.height || 'auto' };
  padding: 16px;
  background-color: rgba(255,255,255,0.95);
  box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.5);
  border-radius: 0 0 8px 8px;
  transition: top 0.2s ease-out;
	z-index: ${props => props.open ? '22' : '1'};
	max-height: 50vh;
	overflow-y: auto;
`;

const FilterContainer = styled.div`
  display: inline-block;
  height: 60px;
	position: relative;
	min-width: 160px;

	@media (max-width: 1350px) {
		min-width: 0;
	}

  &:nth-last-child(1) ${FilterName} {
    border-right: 0px;
  }
`;

const InvisibleToggle = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 20;
`;


const Filter = props => {
	const { t, lng } = props;
	let options = null;

	switch (props.type) {
	case 'range':
		options = <Range {...props} />;
		break;
	case 'select':
	default:
		options = [];

		(lng in props.options ? props.options[lng] : props.options).forEach((option, optionIndex) => {
			options.push(
				<FilterOption
					key={props.id + option.value}
					id={props.id + option.value}
					{...optionIndex}
					{...option}
					checkHandler={() => props.checkHandler(props.id, optionIndex)}
				/>
			);
		});
		break;
	}

	return (
		<FilterContainer>
			<FilterName
				role="button"
				tabindex="1"
				onClick={() => props.openHandler(props.open ? null : props.id)}
				open={props.open}
				hasSelected={props.hasSelected}
			>{t(props.name)}</FilterName>
			<FilterOptionsContainer
				open={props.open}
				width={props.type === 'range' ? '300px' : '200px'}
				left={props.left || '0px'}
				right={props.right || 'auto'}>
				{options}
			</FilterOptionsContainer>
			{
				props.open &&
				<InvisibleToggle onClick={() => props.openHandler(null)} />
			}
		</FilterContainer>
	);
}

Filter.propTypes = {
	t: PropTypes.any,
	lng: PropTypes.string,
	id: PropTypes.string,
	type: PropTypes.string,
	name: PropTypes.string,
	open: PropTypes.bool,
	openHandler: PropTypes.func,
	hasSelected: PropTypes.bool,
	left: PropTypes.number,
	right: PropTypes.number,
	options: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.string,
			name: PropTypes.string,
			selected: PropTypes.bool,
		}))
	]),
	filterOpenHandler: PropTypes.func,
	checkHandler: PropTypes.func,
}

export default translate('translations')(Filter)
export {
	FilterContainer,
	FilterName,
	InvisibleToggle,
	FilterOptionsContainer
}
